import { useState, useEffect, useContext } from "react";
import { useSelector } from "react-redux";
import { ServiceContext } from "@msx/platform-services";
import { DataServiceContext } from "../../../../../app/context";
import { getDismissedAnnouncements } from "../../../../store";

/**
 * useAnnouncements — Manages announcement data fetching, filtering, and dialog state.
 *
 * Extracted from V2_Shell.tsx (PR #2, Phase 1).
 * Zero logic changes — pure cut-paste extraction.
 *
 * useState moved: announcementJsondataa, filteredAnnouncementss, hideDialog
 * Functions moved: SetAnnouncmentData, filterAndSort, toggleHideDialog
 * Effects moved: Effect #1 (fetch announcement JSON on mount)
 */
export const useAnnouncements = () => {
  const { dataService } = useContext(DataServiceContext);
  let dismissedAnnouncements = useSelector(getDismissedAnnouncements);
  const sastoken = sessionStorage.getItem("SasTokenKey") || "";

  const [announcementJsondataa, setAnnouncementJsondataa] = useState(null);
  const [filteredAnnouncementss, setfilteredAnnouncementss] = useState(null);
  const [hideDialog, setHideDialog] = useState(true);

  const filterAndSort = (announcements) => {
    return announcements
      ?.filter((announcement) => {
        const startDate = new Date(announcement.startDate);
        const endDate = new Date(announcement.endDate);
        let currentDate = new Date();
        return endDate > currentDate && startDate <= currentDate;
      })
      .sort((a, b) => {
        const dateA = new Date(a.startDate).getTime();
        const dateB = new Date(b.startDate).getTime();
        return dateB - dateA;
      });
  };

  const SetAnnouncmentData = async (data) => {
    setAnnouncementJsondataa(data);
    const FilterData = filterAndSort(data?.Announcements);
    FilterData?.filter(
      (announcement) =>
        !dismissedAnnouncements.some(
          (dismissed) => dismissed.id === announcement.id
        )
    );
    setfilteredAnnouncementss(FilterData);
  };

  const toggleHideDialog = (dontShowAgain: boolean) => {
    if (dontShowAgain) {
      announcementJsondataa.Announcements.forEach((val) =>
        dismissedAnnouncements.push({ id: val.id, expiryDate: val.endDate })
      );

      localStorage.setItem(
        "dismissedAnnouncements",
        JSON.stringify(dismissedAnnouncements)
      );
    }
    setHideDialog(!hideDialog);
  };

  // 1. useEffect
  useEffect(() => {
    const fetchData = async () => {
      try {
        const jsonData = `${process.env.REACT_APP_BLOBSASSTART +
          "announcement/json/announcement.json" +
          sastoken
          }`;

        const response = await fetch(jsonData, {
          headers: {
            "Content-Type": "application/json; charset=utf-8",
          },
        });
        const data = await response?.json();
        SetAnnouncmentData(data);
      } catch (error) {
        const jsonData = await dataService?.GetAnnouncements();
        SetAnnouncmentData(jsonData);
      }
    };
    fetchData();
  }, [dataService]);

  return {
    announcementJsondataa,
    setAnnouncementJsondataa,
    filteredAnnouncementss,
    setfilteredAnnouncementss,
    hideDialog,
    setHideDialog,
    SetAnnouncmentData,
    filterAndSort,
    toggleHideDialog,
    dismissedAnnouncements,
  };
};
